import http from '@/utils/http'
export const login = data => http.post('kg-auth/oauth/token/json',
     data,
) //login 的请求接口
export const freshlogin = data => http.post('kg-auth/oauth/token/json',
     data,
)
export const ramdom = data => http.get('kg-auth/oauth/images/captcha', {
     params: data,
     responseType: 'arraybuffer',
}, )
export const getUserInfo = () => http.get('/user-center/api/user/info')
export const logout = data => http.delete('/kg-auth/oauth/logout', {
     params: data
})
export default {
     login,
     ramdom,
     getUserInfo,
     freshlogin,
     logout
}